<!-- Pour les dates -->
<button mat-button matSuffix mat-icon-button
        aria-label="Clear"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="matMenu">
  <mat-icon [ngStyle]="{'color': buttonIconColor}">filter_list</mat-icon>
</button>

<mat-menu #menuEmpty>Not init</mat-menu>

<mat-menu #menuFilterDate>
  <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()" style="padding: 4px;">
      <label>{{'Date de début' | translate}}</label>
      <armaDateTimePicker [disabled]="false"
                          [(ngModelDate)]="columnFilterDate?.beginDate.date"
                          (dateChange)="onChange.emit()">
      </armaDateTimePicker>
      <br>
      <label>{{'Date de fin' | translate}}</label>
      <armaDateTimePicker [disabled]="false"
                          [(ngModelDate)]="columnFilterDate?.endDate.date"
                          (dateChange)="onChange.emit()">
      </armaDateTimePicker>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #menuFilterCheck>
  <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()">
      <mat-checkbox class="mat-menu-item"
                    (change)="onChange.emit()"
                    [(ngModel)]="columnFilterCheck.allSelected">
        {{ "Tout" | translate }}
      </mat-checkbox>
      <mat-checkbox class="mat-menu-item"
                    (change)="onChange.emit()"
                    [(ngModel)]="item.selected"
                    *ngFor="let item of columnFilterCheck.filters">
        <ng-container *ngIf="item.filterValue; then thenFilterValue else elseEmptyValue"></ng-container>
        <ng-template #thenFilterValue>{{item.filterValue}}</ng-template>
        <ng-template #elseEmptyValue>({{"Empty" | translate}})</ng-template>
      </mat-checkbox>
    </div>
  </ng-template>
</mat-menu>
